import InfoOutlined from "@mui/icons-material/InfoOutlined";
import {
  IconButton,
  IconButtonOwnProps,
  SvgIconOwnProps,
  Typography,
  TypographyStyle,
} from "@mui/material";
import { BigTooltip } from "components/BigTooltip";
import { useMemo } from "react";

export const InfoIconTooltip = ({
  tooltip,
  fontSize = "inherit",
  iconButtonSx,
  svgIconSx,
}: {
  tooltip: React.ReactNode;
  fontSize?: TypographyStyle["fontSize"];
  iconButtonSx?: IconButtonOwnProps["sx"];
  svgIconSx?: SvgIconOwnProps["sx"];
}) => {
  const tooltipDisplayElement = useMemo(() => {
    if (!tooltip) return undefined;
    if (typeof tooltip === "string") {
      return <Typography variant="caption">{tooltip}</Typography>;
    }
    return tooltip;
  }, [tooltip]);
  return (
    <BigTooltip title={tooltipDisplayElement}>
      <IconButton
        size="small"
        sx={{
          ...iconButtonSx,
        }}
      >
        <InfoOutlined
          sx={{
            ...svgIconSx,
            fontSize: fontSize,
          }}
          color="disabled"
        />
      </IconButton>
    </BigTooltip>
  );
};
